import { axiosInstance } from "./axios";
import { IPreview } from "dto/IPreview";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { IError } from "dto/IError";

const queryKeys = {
  getPreview: (id: string, full?: boolean) => [
    "emailService.getPreview",
    id,
    full,
  ],
  // getFile: (payload: IGetFile) => ['emailService.getFile', ],
};

const getPreview = (
  id: string,
  full?: boolean
): Promise<{ data: IPreview }> => {
  const query = new URLSearchParams(window.location.search);
  query.append("id", id);

  if (full !== null) {
    query.append("full", full ? "true" : "false");
  }

  return axiosInstance.get(`/Email/Preview?${query}`);
};

const useGetPreview = (id: string, full?: boolean, enabled: boolean = true) => {
  return useCustomQuery(
    queryKeys.getPreview(id, full),
    () => getPreview(id, full),
    {
      enabled: enabled,
    }
  );
};

export interface IGetFile {
  id: string;
  mailId: string;
}

const getFile = async (payload: IGetFile): Promise<{ data: Blob }> => {
  return await axiosInstance.get(
    `/email/attachment?id=${payload.id}&mailId=${payload.mailId}`
  );
};

const useGetFile = () => {
  return useCustomMutation(getFile);
};

const sync = (): Promise<{ data: IError }> => {
  return axiosInstance.post("/email/sync");
};

const useSync = () => {
  return useCustomMutation(sync);
};

export default {
  useGetPreview,
  useGetFile,
  useSync,
};
